import { render, staticRenderFns } from "./Online.vue?vue&type=template&id=0235c211&scoped=true&"
import script from "./Online.vue?vue&type=script&lang=js&"
export * from "./Online.vue?vue&type=script&lang=js&"
import style0 from "./Online.vue?vue&type=style&index=0&id=0235c211&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0235c211",
  null
  
)

export default component.exports